
import { Component, Prop, Vue } from 'nuxt-property-decorator';
import {
  contentBlockImagePlacementModifiersMap,
  MultiRowsBlockListItemModel,
  MultiRowsBlockSettingsModel,
} from 'fourwaves-shared';
import { RawHtml } from 'fourwaves-shared/components';
import {
  contentBlockImageSizeModifiersMap,
  contentBlockTextVerticalAlignmentModifiersMap,
} from 'fourwaves-shared/src/services';
import ContentBlockImage from '../ContentBlockImage.vue';
import ContentBlockButton from '../ContentBlockButton.vue';

@Component({
  components: {
    RawHtml,
    ContentBlockImage,
    ContentBlockButton,
  },
})
export default class MultiRowsBlockListItem extends Vue {
  @Prop({ type: Object, required: true }) readonly item!: MultiRowsBlockListItemModel;
  @Prop({ type: Object, required: true }) readonly settings!: MultiRowsBlockSettingsModel;

  get itemClassNames(): string[] {
    return [
      ...(this.settings.withImage ? ['-with-image'] : []),
      contentBlockImageSizeModifiersMap[this.settings.imageSize],
      contentBlockImagePlacementModifiersMap[this.settings.imagePlacement],
      contentBlockTextVerticalAlignmentModifiersMap[this.settings.textVerticalAlignment],
    ];
  }
}
